var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesDraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06707 12.8286L9.56192 12.274C10.1691 11.5935 11.2585 11.6819 11.7479 12.4515C12.2038 13.1683 13.1943 13.3042 13.8265 12.7366L14.7235 11.9313M2.69531 12.9799L5.60597 12.3934C5.76049 12.3623 5.90236 12.2862 6.01379 12.1747L12.5296 5.65538C12.842 5.34281 12.8418 4.83615 12.5291 4.52385L11.1488 3.14513C10.8363 2.83295 10.3299 2.83316 10.0176 3.1456L3.50115 9.66564C3.38995 9.77691 3.31401 9.9185 3.28285 10.0727L2.69531 12.9799Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesDraw);
export default __webpack_public_path__ + "static/media/yes-draw.084c279eafcb0492c3c13673efb8dfa9.svg";
export { ForwardRef as ReactComponent };